module.exports = __webpack_public_path__ + "img/group-7-copy.260f64d6.svg";